package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class AnalyticsOverviewDto(
    val totalLikes: Long,
    val totalStreams: Long,
    val uniqueListeners: Long,
    val totalListeningHours: Double,
    val avgCompletionRate: Double,
    val avgMinutesPerEpisode: Double,
    val likes30d: Long,
    val streams30d: Long
)

@Serializable
data class TimeSeriesPoint(
    val date: String,
    val value: Long
)

@Serializable
data class AnalyticsTrendsDto(
    val dailyStreams: List<TimeSeriesPoint>,
    val dailyLikes: List<TimeSeriesPoint>,
    val contentTypeBreakdown: Map<String, Long>
)

@Serializable
data class TopContentItem(
    val contentId: String,
    val title: String,
    val contentType: String,
    val metricValue: Long
)

@Serializable
data class AnalyticsTopContentDto(
    val topByLikes: List<TopContentItem>,
    val topByStreams: List<TopContentItem>,
    val topByCompletions: List<TopContentItem>,
    val mostSkipped: List<TopContentItem>,
    val overHyped: List<TopContentItem>,
    val underDiscovered: List<TopContentItem>
)

@Serializable
data class AudiobookEngagement(
    val contentId: String,
    val title: String,
    val totalStreams: Long,
    val avgMinutesListened: Double,
    val avgCompletionRate: Double,
    val skipRate: Double
)

@Serializable
data class EpisodeEngagement(
    val episodeId: String,
    val episodeTitle: String,
    val parentTitle: String,
    val totalStreams: Long,
    val avgMinutesReached: Double,
    val avgCompletionPct: Double,
    val skipCount: Long
)

@Serializable
data class AnalyticsEngagementDto(
    val audiobookEngagement: List<AudiobookEngagement>,
    val mostSkippedEpisodes: List<EpisodeEngagement>,
    val avgMinutesAll: Double,
    val avgMinutesAudiobook: Double,
    val avgMinutesPodcast: Double
)

@Serializable
data class RetentionCohort(
    val cohortWeek: String,
    val cohortSize: Int,
    val retainedByWeek: List<Int>
)

@Serializable
data class NewVsReturningPoint(
    val date: String,
    val newUsers: Int,
    val returningUsers: Int
)

@Serializable
data class AnalyticsRetentionDto(
    val cohorts: List<RetentionCohort>,
    val newVsReturning: List<NewVsReturningPoint>
)

@Serializable
data class HeatmapCell(
    val dayOfWeek: Int,
    val hour: Int,
    val count: Long
)

@Serializable
data class AnalyticsHeatmapDto(
    val cells: List<HeatmapCell>
)

@Serializable
data class ContentHealthItem(
    val contentId: String,
    val title: String,
    val contentType: String,
    val createdAt: String
)

@Serializable
data class AnalyticsHealthDto(
    val zeroStreamContent: List<ContentHealthItem>,
    val audiobooksNoEpisodes: List<ContentHealthItem>,
    val episodesZeroDuration: List<ContentHealthItem>,
    val draftContentCount: Int
)
